export enum OrderDealState {
  ACTIVE,
  FILL_ERROR,
  COMPLETED,
  CANCELLED,
  ACK_TIME_OUT,
  NAK,
  DONE_NO_STP,
  STP_HOLD,
  PENDING,
  FILL_PENDING,
  FILL_CANCEL,
}

export namespace OrderDealState {
  let elements = [
    OrderDealState.ACTIVE,
    OrderDealState.FILL_ERROR,
    OrderDealState.COMPLETED,
    OrderDealState.CANCELLED,
    OrderDealState.ACK_TIME_OUT,
    OrderDealState.NAK,
    OrderDealState.DONE_NO_STP,
    OrderDealState.STP_HOLD,
    OrderDealState.PENDING,
    OrderDealState.FILL_PENDING,
    OrderDealState.FILL_CANCEL,
  ];
  let alias = "com.bcdfx.model.OrderDealState";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
